/* eslint-disable jsx-a11y/anchor-is-valid */
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Moment } from "moment";
import { Link } from "react-router-dom";
import { mConstants } from "../../../../../helper/constants";
import helper from "../../../../../helper/helper";
import { IoPagination } from "../../../../../helper/pagination";
import { Action, ActionType } from "../../../customer/entity/customer.model";
import { TaskStatus, TaskUI } from "../../entity/task.model";

export const taskTableColumns: ColumnsType<TaskUI> = [
  {
    title: "Д/д",
    dataIndex: "index",
    key: "index",
  },
  {
    title: "Хэрэглэгчийн нэр",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Төлөв",
    dataIndex: "status",
    key: "status",
    render: (status: TaskStatus) => {
      return helper.getTaskStatus(status);
    },
  },
  {
    title: "Огноо",
    dataIndex: "date",
    key: "date",
    render: (date: Moment) => date.format(mConstants.DATE_FORMAT),
  },
  {
    title: "Харилцагч",
    dataIndex: "companyName",
    key: "companyName",
  },
  {
    title: "Төрөл",
    dataIndex: "taskType",
    key: "taskType",
    render: (taskType: string) => {
      if (taskType === "SALES") {
        return "Борлуулалт";
      } else if (taskType === "STALL") {
        return "Өрөлт";
      } else {
        return "Тодорхойгүй";
      }
    },
  },
  {
    title: "Үйлдлүүд",
    align: "center",
    key: "actions",
    dataIndex: "actions",
    render: (actions: Action[], record: TaskUI) => (
      <div className="list-icons">
        <div className="dropdown">
          <a href="#" className="list-icons-item" data-toggle="dropdown">
            <i className="icon-menu9"></i>
          </a>

          <div className="dropdown-menu dropdown-menu-right">
            {actions.map((action: Action) => {
              if (action.type === ActionType.edit) {
                return (
                  <Link
                    key={`action-${record.uuid}`}
                    to={`/tasks/${record.uuid}`}
                    className="dropdown-item"
                  >
                    <i className={action.icon}></i>
                    {action.text}
                  </Link>
                );
              } else {
                return <></>;
              }
            })}
          </div>
        </div>
      </div>
    ),
  },
];

export interface TaskTableProps {
  pagination: IoPagination<TaskUI>;
  onChange: (page: number, pageSize: number) => void;
}

function TaskTable(props: TaskTableProps) {
  const taskUIs: TaskUI[] = props.pagination.content.map((task, index) => {
    const actions: Action[] = [
      { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
    ];
    return {
      ...task,
      actions: actions,
      index: index + 1,
      key: index,
    };
  });

  return (
    <Table
      className="table table-responsive"
      columns={taskTableColumns}
      dataSource={taskUIs}
      pagination={{
        defaultCurrent: props.pagination.current,
        total: props.pagination.totalElements,
        onChange: props.onChange,
      }}
    />
  );
}

export default TaskTable;
